import { render, staticRenderFns } from "./sector-table.vue?vue&type=template&id=e72ea0b0&scoped=true&"
import script from "./sector-table.ts?vue&type=script&lang=ts&"
export * from "./sector-table.ts?vue&type=script&lang=ts&"
import style0 from "./sector-table.scss?vue&type=style&index=0&id=e72ea0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72ea0b0",
  null
  
)

export default component.exports